import React from "react";
import { Box, Column, Columns, Input } from "@allxsmith/bestax-bulma";




export default function CashSaleSection({data, index, onChange}){
    // it expects onChange to take event and index
    return (
        <Box>
            <Columns isMultiline>
                <Column>
                    <label className="label">Name (*)</label>
                    <Input
                        type={"text"}
                        name={"name"}
                        value={data.name}
                        onChange={e => onChange(e, index)}
                    />
                </Column>
                <Column>
                    <label className="label">Email</label>
                    <Input
                        type={"email"}
                        name={"email"}
                        value={data.email}
                        onChange={e => onChange(e, index)}
                    />
                </Column>
                <Column>
                    <label className="label">Phone Number</label>
                    <Input
                        name={"phone"}
                        value={data.phone}
                        onChange={e => onChange(e, index)}
                    />
                </Column>
                <Column>
                    <label className="label">Address (*)</label>
                    <Input
                        name={"address"}
                        value={data.address}
                        onChange={e => onChange(e, index)}
                    />
                </Column>
            </Columns>
        </Box>
    );



}